import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumbsGeneric from "../../components/Nav/BreadCrumbsGeneric";
import SoporteController from "../../controllers/SoporteController";
import {
  ArrowLeftIcon,
  ArrowDownIcon,
  ArrowNarrowUpIcon,
} from "@heroicons/react/solid";
import { UseContextApp } from "../../Global/Context/appContext";
import "../../index.css";
import Spinner from "../../components/Loading/loadingSpinner/Spinner";
import { colors } from "../../propsType/Colors";
import moment from "moment";

function ViewReports() {
  const { getTicketByCustom } = SoporteController();
  //Location para saber en la ruta que estas actualmente  
  const location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [topTips, setTopTips] = useState(false);
  const [indexMessage, setIndexMessage] = useState();

  const getReport = async () => {
    setLoading(true);
    const res = await getTicketByCustom();
     if (res) {
      let data = res?.soporte?.tickets?.map((item) => {
  
        return {
          numeroRporte: item.ticketNumber,
          fecha: item.createdTime.split(" ")[0],
          reporte: item.resolution,
          service: item.category,
          status: item.statusTicket,
          statusTicket: item.statusTicket,
          description: item.subject,
        };
      });
      setReports(data);
      setLoading(false);
    }

 
  };
  //Funcion para mostrar el toptips Message
  function closeTopTips(e) {
    if (topTips) {
      setTopTips(!topTips);
    }
  }
  const onMessage = (msn, index) => {
    setIndexMessage(index);

    setTopTips(true);

  
  };
  //Orderna los reportes por fechas
  const orderDate = () => {
    let res = reports.reverse();
   
    setReports([...res]);
  };

  useEffect(() => {
    getReport();
  
  }, []);

  return (
    <div
      className=" bg-[#f3f4f6] "
      onClick={(event) => {
        closeTopTips();
      }}
    >
      <div className="flex max-w-7xl mx-auto  pt-6 justify-center min-h-screen">
        {loading ? (
          <>
            <div className="w-full h-screen flex justify-center items-center ">
              <Spinner title={"Espere..."} />
            </div>
          </>
        ) : (
          <>
            <div className="flex lg:w-full px-4   gap-5 flex-col">
             {/*   Recibe la navegacion que te indica en que ruta estas */}
              <BreadCrumbsGeneric locations={pathName} />
              <button
                className="bg-white w-[40%] md:w-[10%] h-11 flex justify-center items-center rounded-md shadow px-6  space-x-4"
                onClick={() => navigate(-1)}
              >
                <div className="flex w-full justify-between items-center">
                  <div>
                    <ArrowLeftIcon className="h-5 w-5" />
                  </div>
                  <div>Volver</div>
                </div>
              </button>
              <div className="bg-white rounded-[10px] lg:mb-28 ">
                <div className="py-6 px-6 sm:px-6">
                  <div className="py-2 text-2xl font-medium ">Reportes </div>
                  <div className=" text-lg font-regular ">
                    Consulta el estado y detalle de tus requerimientos o casos;
                    puedes visualizar todos los casos abiertos y casos cerrados
                    de los últimos 3 meses.
                  </div>
                </div>
                <div className="!m-0  sm:-mx-6 lg:-mx-8 bg-white rounded-[10px] shadow-lg  mt-5 ">
                  {reports?.length > 0 ? (
                    <>
                      <div className="bg-white shadow overflow-hidden sm:rounded-md">
                        <ul role="list" className="divide-y divide-gray-200">
                          <div className=" hidden px-4 py-2 md:grid gap-4 lg:grid-cols-6 sm:px-6 border-b border-gray-200">
                            <div
                              className={`font-medium text-center flex justify-center pl-9 gap-2  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              <div>Fecha</div>
                              <div
                                className="flex justify-end items-center cursor-pointer decoration-txt"
                                onClick={() => orderDate()}
                              >
                                <ArrowDownIcon className="h-3 w-3" />
                                <ArrowNarrowUpIcon className="h-3 w-3" />
                              </div>
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Número de Caso
                            </div>
                            <div
                              className={`font-medium text-center  text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Servicio
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Descripción del Ticket
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Respuesta del Ticket
                            </div>
                            <div
                              className={`font-medium  text-center text-[14px] text-[${colors.darkBlue}]`}
                            >
                              Estado
                            </div>
                          </div>
                          {reports?.map((data, index) => (
                            <li key={index}>
                              <div className="px-4 py-4 grid gap-4 lg:grid-cols-6 sm:px-6 group-hover:bg-gray-50">
                                <div className="mt-2 flex gap-2  flex-col items-center text-sm text-gray-500 sm:mt-0 sm:ml-6">
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                    Fecha
                                  </div>
                                  <div className="flex">{data.fecha}</div>
                                </div>
                                <div
                                  className={`text-sm text-start flex-col justify-center flex items-center font-medium text-[${colors.lightBlue}]  truncate`}
                                >
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                    Número de Caso
                                  </div>
                                  {data.numeroRporte}
                                </div>
                                <div>
                                  <div className="flex items-center gap-2 flex-col text-sm text-gray-500">
                                    <div className="font-medium text-[14px] md:hidden block  ">
                                      Servicio
                                    </div>
                                    <div className="flex">{data.service}</div>
                                  </div>
                                </div>
                                <div className="mt-2 flex gap-2 flex-col items-center text-sm  text-gray-500 sm:mt-0">
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                  Descripción del Ticket
                                  </div>
                                  <div className="flex">
                                    {data.description.length > 20 ? (
                                      <>
                                        <div
                                          className="button cursor-pointer decoration-txt"
                                          data-tooltip={data.description}
                                        >
                                          {data.description.substr(0, 20)}...
                                        </div>
                                      </>
                                    ) : (
                                      <>{data.description}</>
                                    )}
                                  </div>
                                </div>
                                <div className="mt-2 flex gap-2 flex-col items-center text-sm  text-gray-500 sm:mt-0">
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                  Respuesta del Ticket
                                  </div>
                                  <div className="flex">
                                    {data.reporte.length > 20 ? (
                                      <>
                                        <div
                                          className="button cursor-pointer sroll-bar decoration-txt"
                                          data-tooltip={data.reporte}
                                        >
                                          {data.reporte.substr(0, 20)}...
                                        </div>
                                      </>
                                    ) : (
                                      <>{data.reporte}</>
                                    )}
                                  </div>
                                </div>
                                <div className="mt-2 flex gap-2 flex-col items-center text-sm  text-gray-500 sm:mt-">
                                  <div className="font-medium text-[14px] md:hidden block  ">
                                    Estado
                                  </div>
                                  <div className="flex">
                                    {data.statusTicket.length > 20 ? (
                                      <>
                                        <div
                                          className="button cursor-pointer decoration-txt"
                                          data-tooltip={data.statusTicket}
                                        >
                                          {data.statusTicket.substr(0, 20)}...
                                        </div>
                                      </>
                                    ) : (
                                      <>{data.statusTicket}</>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="h-[20vh] flex justify-center items-center text-[1.3rem] font-semibold">
                        No posees reportes en estos momentos
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ViewReports;
